<script>
    import {api, api_internal, store} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import TopMenu_BackBtn from '../components/TopMenu_BackBtn.svelte';
    import Loading from '../components/Loading.svelte';
    import ImageCMS from '../components/ImageCMS.svelte';
    import TestSwitch from '../components/tests/TestSwitch.svelte';
    import LoadingCard from '../components/LoadingCard.svelte';

    const user = store('credentials', 'appUserAuth');
    const detach = (node) => node ? node.parentNode.removeChild(node) : null;
    
    export let evid = '';
    export let tid = '';

    const fetchEvent = (async () => {
        let result = await api('getEvent', {idEvent: evid, emailEventMember: $user.email});
        return result.data ? result.data : [];
    })();
    
    let title = null;
    let data = null;
    let prev = null;
    
    const fetchItem = (async () => {
        let event = await fetchEvent,
            tests = event.tests;
        
        let result = await api_internal('publication', {uuid: tid});
    
        result.data.content.test = null;
        if (result.data.content.full) {
            result.data.content.full = parseB64Code(result.data.content.full);
            result.data.content.test = tests.find((el) => el.idTest === result.data.content.full.id) || null;
        }
        
        return result.data ? result.data : [];
    })();

    const handlerStart = (async (e) => {
        e.target.parentNode.parentNode.removeChild(e.currentTarget.parentNode);

        let result = await fetchItem;
    
        title = result.title;
        data = result.content.full;
        prev = result.content.test;
    });
</script>

<TopMenu title="Тесты, опросы и игры">
    <TopMenu_BackBtn slot="back" href="/events/view/{evid}/tests" />
</TopMenu>

<div id="appCapsule">
    {#await fetchEvent}
        <LoadingCard />
    {:then event}
        {#await fetchItem}
            <LoadingCard />
        {:then data}
            <div class="section mt-3 mb-3">
                <div class="row">
                    <div class="col-12 col-md-10 col-lg-8 mx-md-auto">
                        <div class="card">
                            {#if data.files && data.files[0]}
                                <ImageCMS src="{data.files[0].path.middle}" class="card-img-top" alt="{data.title}" style="height: 300px; width:100%; object-fit: cover;" />
                            {/if}
        
                            {#if data.content.test !== null}
                                <div class="chip chip-media" style="position: absolute; right: 10px; top: 10px; box-shadow: 0 3px 6px 0 rgb(0 0 0 / 10%), 0 1px 3px 0 rgb(0 0 0 / 8%);">
                                    <i class="chip-icon bg-primary">
                                        <ion-icon name="ribbon-outline"></ion-icon>
                                    </i>
                                    {#if !data.content.test.state}
                                        <span class="chip-label">{data.content.test.test} МИИНок</span>
                                    {:else}
                                        <span class="chip-label">Пройдено</span>
                                    {/if}
                                </div>
                            {/if}
            
                            <div class="card-body">
                                <h2 class="title text-md-center">{data.title}</h2>
                                <div class="card-text text-md-center">{@html data.content.short}</div>
                            </div>
            
                            <div class="card-footer text-center">
                                {#if data.content.test !== null && data.content.test.state}
                                    <div class="alert alert-outline-secondary fade show mb-2 text-center" role="alert">
                                        {data.content.test.state}
                                    </div>
                                {/if}
                                
                                <button type="button" class="btn {data.content.test === null ? 'btn-primary' : 'btn-secondary'} btn-block" on:click={handlerStart}>
                                    {data.content.test === null ? 'Начать' : 'Пройти снова'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {/await}
        
        <TestSwitch evid="{evid}" tid="{tid}" title="{title}" {data} {prev} />
    {/await}
</div>
